export const socialsData = {
  github: "https://github.com/Sagar160301",
  facebook: "https://www.facebook.com/sagar.kumar.16032001",
  linkedIn: "https://www.linkedin.com/in/sagar-pradhan16/",
  instagram: "https://www.instagram.com/reaver.16/",
  codepen: "https://codepen.io/",
  twitter: "https://twitter.com/SagarKu78966216",
  reddit: "https://www.reddit.com/user/",
  blogger: "https://www.blogger.com/",
  medium: "https://medium.com/@sagarkumarpradhan2001",
  stackOverflow: "https://stackoverflow.com/users/18568258/sagar-pradhan",
  gitlab: "https://gitlab.com/",
  youtube: "https://youtube.com/channel/UCR7LqSZBeFy8BqfMnqaQbmQ",
};
